//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import event_item_mixin from '@/common/mixins/event_item_mixin'
import SingleImg from '@/components/views/event_single_img'
import call_consultant from '@/common/mixins/callConsultant'
import event_img from '../../../common/wxs/event_img'
import { UserLog } from '@/utils/log'
import { openChatWidthUserInfo } from '@/data/im'
export default {
    components: {
        SingleImg
    },
    mixins: [
        event_item_mixin,
        call_consultant,
        event_img
    ],
    methods: {
        goVideoPage (video, title) {
            this.$router.push({
                path:`/building/video?building_id=${this.building_id}&src=${video}&title=${title}`
            })
        },
        makePhone (e) {
            this.$sendCtmEvtLog(`${this.page}-在售楼盘动态展位电话咨询`)
            this.callConsultant(e)
        },
        openChat (e) {
            this.$sendCtmEvtLog(`${this.page}-在售楼盘动态展位打开微聊`)
            openChatWidthUserInfo(e)
        }
    },
    props: {
        page: String,
        photos_url: String,
        building_id: {
            type: [Number, String],
        },
        item: {
            type: Object
        },
        has_line: {
            type: Boolean,
            default: true
        }
    }
}
